export default {
	ProductHOPS: 0,
	Membership: 1,
	RailwayProduct: 2,
	TicketTravel: 3,
	TicketSession: 4,
	SeatReservation: 5,
	VoucherSale: 6,
	Shares: 7,
	DeliveryMethod: 8,
	PaymentMethod: 9,
	System: 10,
	GiftCardInventory: 12, // For selling
	GiftCardInstance: 13, // For redeeming
	TicketProtectionInstance: 14
};
